(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('GraphicArchiveItemSearch', GraphicArchiveItemSearch);

    GraphicArchiveItemSearch.$inject = ['$resource'];

    function GraphicArchiveItemSearch($resource) {
        var resourceUrl =  'api/_search/graphic-archive-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
